import React from "react";
import "./App.css";
import Images from "./component/Images";

function App() {
  return (
    <div className="App">
      <Images />
    </div>
  );
}

export default App;
